import { PollWithResults } from '@core/types';
import { ActivePollStatus } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';
import { SSPollQuestionText } from '../../../atoms/self-service';
import { SSPollAnswers } from '../SSPollAnswers';
import { SSPollResults } from '../SSPollResults';

interface Props {
    shown: boolean;
    hasVotedOnPoll: boolean;
    activePoll: PollWithResults;
    activePollStatus: ActivePollStatus;
    isOnDemand?: boolean;
    /** Referenced by the toggle button's aria-controls. */
    id: string;
}
export const SSPollContent = ({ shown, hasVotedOnPoll, activePoll, activePollStatus, isOnDemand, id }: Props) => {
    const { t } = useTranslation();
    return (
        // A closed drawer only slides off-screen; inert keeps its answers out of the tab order and the accessibility tree
        <div
            id={id}
            inert={!shown}
            className={`h-full bg-white/80 pt-3 pb-2 pl-2 pointer-events-auto transform transition-transform duration-300 ${shown ? 'transform-none' : 'translate-x-full'}`}
        >
            <div className="max-h-[calc(100%-1.25rem)] bg-white rounded-l-lg shadow-md flex flex-col ml-2 mb-2 mt-3 p-3">
                <SSPollQuestionText question={activePoll.question} />
                {activePoll.publicResults && (hasVotedOnPoll || activePollStatus === ActivePollStatus.Closed) && <SSPollResults poll={activePoll} />}
                {!activePoll.publicResults && (hasVotedOnPoll || activePollStatus === ActivePollStatus.Closed) && (
                    <p className="pt-4 pb-2">{t('Player.Poll.ResultsAtEndMessage')}</p>
                )}
                {!hasVotedOnPoll && activePollStatus === ActivePollStatus.Active && <SSPollAnswers shown={shown} poll={activePoll} isOnDemand={isOnDemand} />}
            </div>
        </div>
    );
};
